import React from "react";
import { Button, Container } from "react-bootstrap";
import TopHeader from "../Common/TopHeader";
import { GetApiMethod, PutApiMethod } from "../../core/services/apiService";
import TooltipPositioned from "../Tooltip/TooltipPositioned";
import FilterComponent from "../Common/FilterComponent";
import AppModal from "../AppModal/AppModal";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";
import { hideToaster, showToaster } from "../../core/redux/toastSlice";
import { PhoneNumberFormatter, CheckPropertyExistOrNot, RemoveExtraCharsFromNumber, DisplayToaster, getRecordingInfo, loggerHelper, GetTenantId } from "../../core/services/sharedService";
import DataTable from "react-data-table-component";
import AppLoaderTable from "../AppLoader/AppLoaderTable";
import notificationsSlice, { setOutBoundCallLocationDetails, setOutBoundCallPhoneNumber, setVoiceMailNotificationTrigger } from "../../core/redux/notificationsSlice";
import { useNavigate } from "react-router-dom";

const VoicemailReports = () => {
    const [data, setData] = React.useState<any>([]);
    const [showLoader, setShowLoader] = React.useState(true);
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const [showReplayModal, setShowReplayModal] = React.useState<boolean>(false);
    const [replayCallReportInfo, setReplayCallReportInfo] = React.useState<any>();
    const [customLoading, setCustomLoading] = React.useState<boolean>(false);
    const dispatch = useAppDispatch();
    const [totalRows, setTotalRows] = React.useState(0);
    const [perPage, setPerPage] = React.useState(10);
    const [column, setColumn] = React.useState<any>({});
    const [sortDirection, setSortDirection] = React.useState<string>('asc');
    const [startDate, setStartDate] = React.useState<Date | undefined>();
    const [endDate, setEndDate] = React.useState<Date | undefined>(new Date());
    const [page, setPage] = React.useState(1);
    const [callTypeSelectedValues, setCallTypeSelectedValues] = React.useState<string>("");
    const [callDirectionSelectedValues, setCallDirectionSelectedValues] = React.useState<string>("");
    const [callFromSelectedValues, setCallFromSelectedValues] = React.useState<string>("");
    const [callToSelectedValues, setCallToSelectedValues] = React.useState<string>("");
    const [locationSelectedValues, setLocationSelectedValues] = React.useState<string>("");
    const [popupInfo, setPopupInfo] = React.useState<any>();
    const [showTranscriptionModal, setShowTranscriptionModal] = React.useState<boolean>(false);
    const [filterText, setFilterText] = React.useState("");
    const [disableExport, setDisableExport] = React.useState<boolean>(false);
    const reportUrl: string = "tenant/voicemail";
    const [deleteConfirmModal, setDeleteConfirmModal] = React.useState<boolean>(false);
    const [currentExpandedRow, setExpandedCurrentRow] = React.useState(null);

    const formatHoursAMPM = (date: any) => {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        const AmPm = hours >= 12 ? 'pm' : 'am';
        hours %= 12;
        hours = hours || 12;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        seconds = seconds < 10 ? `0${seconds}` : seconds;
        const strTime = `${hours}:${minutes}:${seconds} ${AmPm}`;
        return strTime;
    };
    let LoginUserDetails = useAppSelector((state) => state.auth.users);
    let notificationsSliceSelector = useAppSelector((state) => state.agentNotification);

    const timeFormat = React.useCallback((date: Date, NoNeedTime?: boolean) => {
        let formattedDate = new Date(date);
        let formattedTime: string = "";
        if (NoNeedTime) {
            formattedTime =
                ("00" + (formattedDate.getMonth() + 1)).slice(-2) +
                "-" +
                ("00" + formattedDate.getDate()).slice(-2) +
                "-" +
                formattedDate.getFullYear()
        } else {
            formattedTime =
                ("00" + (formattedDate.getMonth() + 1)).slice(-2) +
                "-" +
                ("00" + formattedDate.getDate()).slice(-2) +
                "-" +
                formattedDate.getFullYear() +
                " " +
                formatHoursAMPM(formattedDate)
        }
        return formattedTime;
    }, []);

    const subHeaderComponent = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };
        return (
            <FilterComponent
                onFilter={(e: any) => { setFilterText(e.target.value); setResetPaginationToggle(!resetPaginationToggle) }}
                onCallTypeSelect={(e: any, filter_type: string) => {
                    (filter_type === "filter_by_type") ? setCallTypeSelectedValues(e.target.value) :
                        (filter_type === "filter_by_call_from") ? setCallFromSelectedValues(e.target.value) :
                            (filter_type === "filter_by_call_to") ? setCallToSelectedValues(e.target.value) :
                                (filter_type === "filter_by_call_direction") ? setCallDirectionSelectedValues(e.target.value) :
                                    (filter_type === "filter_by_location") ? setLocationSelectedValues(e.target.value) :
                                        setCallTypeSelectedValues(e.target.value)

                }}
                onStart={(e: any) => { (e ? setStartDate(new Date(e.setHours(0, 0, 0, 0))) : setStartDate(undefined)); setResetPaginationToggle(!resetPaginationToggle) }}
                onEnd={(e: any) => { e ? setEndDate(new Date(e.setHours(23, 59, 59, 999))) : setEndDate(new Date()); setResetPaginationToggle(!resetPaginationToggle) }}
                selectStart={startDate}
                selectEnd={endDate}
            />
        );
    }, [endDate, resetPaginationToggle, startDate]);

    // To fetch the reports from backend
    const fetchReports = React.useCallback(async () => {
        const response = await GetApiMethod(`${reportUrl}`,
            {
                params: {
                    'page': page,
                    'limit': perPage,
                    'search_text': filterText,
                    'sort_by': column?.sortField ? column.sortField : "",
                    'order_by': sortDirection,
                    'start_date': startDate ? startDate : "",
                    'end_date': endDate ? endDate : new Date(),
                    'filter_by_type': callTypeSelectedValues,
                    'filter_by_call_direction': callDirectionSelectedValues,
                    'filter_by_call_from': callFromSelectedValues,
                    'filter_by_call_to': callToSelectedValues,
                    'filter_by_location': locationSelectedValues
                }
            }
        );
        if (response) {
            setShowLoader(false);
        }

        setData(response.data.data.reports);
        setTotalRows(response.data.data.total_count);
    }, [page, perPage, filterText, column.sortField, sortDirection, startDate, endDate, callTypeSelectedValues, callDirectionSelectedValues, callFromSelectedValues, callToSelectedValues, locationSelectedValues]);

    // To implement server side sorting
    const handleSort = React.useCallback((column: any, sortDirection: any) => {
        setColumn(column);
        setSortDirection(sortDirection);
    }, []);

    React.useEffect(() => {
        fetchReports();
    }, [fetchReports]);

    // To get the data when user click next page
    const handlePageChange = React.useCallback((page: any) => {
        setPage(page);
    }, []);

    function capitalizeFirstLetter(string: string) {
        if (string) return string[0].toUpperCase() + string.slice(1);
    }

    const initiatedTimeView = (row: any) => {
        return (
            <div>
                {TooltipPositioned({
                    placement: "top",
                    item:
                        CheckPropertyExistOrNot(row, "initiated") !== "-"
                            ? timeFormat(CheckPropertyExistOrNot(row, "initiated"))
                            : "-",
                })}
            </div>
        );
    };

    const checkValueIsPhoneNumber = React.useCallback((value: string) => {
        const phoneNumber = value.replace(/\D/g, '');
        if (phoneNumber && phoneNumber.length >= 10 && phoneNumber.length < 12) {
            if (phoneNumber.length === 10) {
                return PhoneNumberFormatter(phoneNumber.toString(), phoneNumber.toString().length);
            }
            return PhoneNumberFormatter(phoneNumber.toString().slice(1), phoneNumber.toString().slice(1).length);
        }
        else
            return value;
    }, []);

    const playCallRecordings = React.useCallback((isCallRecordingReady: string | null = null) => {
        if (isCallRecordingReady) {
            dispatch(hideToaster());
            setShowReplayModal(true);
        } else {
            setShowReplayModal(false);
            dispatch(showToaster(
                {
                    dialogBgColor: "bg-danger",
                    dialogMsg: "We are saving the call recording. Kindly check after few minutes.",
                    showDialog: true,
                    timer: '10000'
                }
            ));
        }
        setCustomLoading(false);
    }, []);

    const getCallRecordings = React.useCallback(async (row: any, isDownload = false) => {
        setCustomLoading(true);
        const res = await getRecordingInfo(row.call_sid);
        if (res && res.data && res.data.mediaUrl) {
            if (!isDownload) {
                setReplayCallReportInfo(res.data);
                playCallRecordings(res.data.mediaUrl);
            } else {
                window.open(res.data.mediaUrl, '_blank');
            }
        } else {
            playCallRecordings();
        }
    }, [])

    const confirmDeleteRecordings = React.useCallback((row: any) => {
        setDeleteConfirmModal(true);
        setPopupInfo(row);

    }, [])

    const deleteRecordings = React.useCallback(() => {
        setDeleteConfirmModal(false);
        let row = popupInfo;
        PutApiMethod('tenant/voicemail/' + row?._id, row).then((res: any) => {
            if (res.data.status === "Success") {
                fetchReports();
            }
        }).catch((err: any) => {
            console.log(err);
        });

    }, [fetchReports, popupInfo])

    const navigate = useNavigate();
    const vendorId = GetTenantId();

    const initiateOutgoingCall = React.useCallback((agentDetails: any) => {
        let details: any = {};
        details._id = agentDetails?.location[0]?._id;
        details.contact = agentDetails?.location[0]?.customer_contact;
        details.vendorId = vendorId;
        details.callerBound = "outgoing call";
        details.agentId = LoginUserDetails._id;
        details.name = agentDetails.location[0].name;
        dispatch(setOutBoundCallPhoneNumber(checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(agentDetails.call_from.toString()))));
        dispatch(setOutBoundCallLocationDetails(details));
        // dispatch(setAgentToAgentOutBoundVoiceCallAgentDetails(udefined));
        // loggerHelper("clicked on initiateOutgoingCall");
        setTimeout(() => {
            navigate("/dashboard");
        }, 500);
    }, [dispatch, navigate])

    const callFromView = (row: any) => {
        return (
            <div>
                <span role="button" onClick={() => { (process.env.REACT_APP_ADMIN !== localStorage.getItem("event") && row.call_from !== "No Caller ID") && initiateOutgoingCall(row) }} className="text-primary">{CheckPropertyExistOrNot(row, 'call_from') !== "-" ?
                    TooltipPositioned({
                        'placement': 'top',
                        'item': (row.type === "voice" ? checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(row.call_from.toString())) :
                            (row.call_direction !== "outgoing call" ? capitalizeFirstLetter(row.call_from) : "-"))
                    })
                    : "-"}</span>
            </div>
        )
    }

    const actionView = (row: any) => {
        return (
            <>
                <div className="cursor-pointer">
                    <i className="bi bi-play-fill ml-2" title='Play' style={{ fontSize: 24 }}
                        onClick={() => {
                            if (!customLoading) { getCallRecordings(row); }
                        }}>
                    </i>
                    <i className="bi bi-download ml-2" title='Download' style={{ fontSize: 24 }}
                        onClick={() => {
                            if (!customLoading) { getCallRecordings(row, true); }
                        }}>
                    </i>
                    <i className="bi bi-trash ml-2" title='Delete' style={{ fontSize: 24 }}
                        onClick={() => {
                            if (!customLoading) { confirmDeleteRecordings(row); }
                        }}>
                    </i>
                </div>
            </>
        );
    };

    const [columns, setColumns] = React.useState<any>(
        [
            {
                name: "Call Type",
                selector: (row: any) => capitalizeFirstLetter((CheckPropertyExistOrNot(row, 'type'))),
                sortable: true,
                cell: (row: any) => (
                    <div><i className="bi bi-telephone-fill pr-2"></i>
                        {capitalizeFirstLetter(CheckPropertyExistOrNot(row, "type"))}
                    </div>
                ),
                id: "call_type",
                sortField: 'type',
            },
            {
                name: "Call Direction",
                selector: (row: any) => capitalizeFirstLetter((CheckPropertyExistOrNot(row, 'call_direction'))),
                sortable: true,
                cell: (row: any) => (
                    <span className="text-danger"><i className="bi bi-x-lg pr-2"></i>
                        {capitalizeFirstLetter(row.call_direction)}
                    </span>
                ),
                id: 'call_direction',
                sortField: 'call_direction',
            },
            {
                name: "Location",
                selector: (row: any) => (('location' in row && row.location[0] && row.location[0].name) ? TooltipPositioned({ 'placement': 'top', 'item': row.location[0].name }) : "-"),
                sortable: true,
                id: 'location',
                sortField: 'location',
            },
            {
                name: "Call From",
                selector: (row: any) => (callFromView(row)),
                sortable: true,
                sortField: 'call_from',
            },
            {
                name: "Call To",
                selector: (row: any) => (CheckPropertyExistOrNot(row, "call_to") !== "-" ?
                    TooltipPositioned({
                        'placement': 'top',
                        item: checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(row.call_to.toString())),
                    })
                    : "-"),
                sortable: true,
                id: 'call_to',
                sortField: 'call_to',
            },
            {
                name: "Initiated Time",
                selector: (row: any) => (timeFormat(CheckPropertyExistOrNot(row, 'initiated'))),
                cell: (row: any) => (
                    initiatedTimeView(row)
                ),
                sortable: true,
                id: 'initiated',
                sortField: 'initiated',
            },
        ]
    );

    React.useEffect(() => {
        setColumns((oldArray: any) => {
            let newColumnValue = [...oldArray];
            let recordingColumn = {
                name: "",
                selector: (row: any) => CheckPropertyExistOrNot(row, "action"),
                sortable: false,
                width: '180px',
                cell: (row: any) => actionView(row),
            };
            if (!newColumnValue.find((x: any) => x.name === "")) {
                newColumnValue.push(recordingColumn);
            }
            return newColumnValue;
        });
        localStorage.setItem("voiceMailNotification", "0");
        dispatch(setVoiceMailNotificationTrigger(!notificationsSliceSelector.voiceMailNotificationTrigger));
    }, []);

    // To handle when user change per page value
    const handlePerRowsChange = React.useCallback(async (newPerPage: any, page: any) => {
        setPerPage(newPerPage);
        setResetPaginationToggle(!resetPaginationToggle);
    }, [resetPaginationToggle]);

    const convertArrayOfObjectsToCSV = (array: any) => {
        let result: any;
        const columnDelimiter = ',';
        const lineDelimiter = '\n';
        const keys = Object.keys(array[0]);

        result = '';
        result += keys.join(columnDelimiter);
        result += lineDelimiter;

        array.forEach((item: any) => {
            let ctr = 0;
            keys.forEach(key => {
                if (ctr > 0) result += columnDelimiter;
                result += item[key];
                ctr++;
            });
            result += lineDelimiter;
        });

        return result;
    }

    const downloadCSV = React.useCallback(async () => {
        let totalReportsArray = [];
        setDisableExport(true);
        let getTotalReports: any;
        if (totalRows <= 0) {
            setDisableExport(false);
            DisplayToaster("bg-danger", "There are no records to export")
        } else {
            getTotalReports = await GetApiMethod(`${reportUrl}`, {
                params: {
                    'page': 1,
                    'limit': totalRows,
                    'search_text': filterText,
                    'sort_by': column?.sortField ? column.sortField : "",
                    'order_by': sortDirection,
                    'start_date': startDate ? startDate : "",
                    'end_date': endDate ? endDate : new Date(),
                    'filter_by_call_direction': callDirectionSelectedValues,
                    'filter_by_call_from': callFromSelectedValues,
                    'filter_by_call_to': callToSelectedValues,
                    'filter_by_location': locationSelectedValues
                }
            });

            totalReportsArray = getTotalReports.data.data.reports;
            if (getTotalReports.data.status) {
                setDisableExport(false);
            }
        }

        const link = document.createElement('a');
        let csvArray: {
            call_type: 'string',
            location: 'string | undefined',
            call_from: 'string | undefined',
            call_to: 'string | undefined',
            initiated: 'string',
            call_direction: 'string | undefined',
        }[] = [];

        totalReportsArray.forEach((item: any) => {
            let newObj: any = {};
            newObj['Call type'] = item.type;
            if ('location' in item && item.location && item.location[0]?.name) {
                newObj['Location'] = item.location[0].name ? item.location[0].name : "-";
            } else {
                newObj['Location'] = "-";
            }
            newObj['Call From'] = item.call_from ? PhoneNumberFormatter(item.call_from.toString().slice(1), item.call_from.toString().slice(1).length) : "-";
            newObj['Call To'] = item.call_to ? PhoneNumberFormatter(item.call_to.toString().slice(1), item.call_to.toString().slice(1).length) : "-";
            newObj['Initiated Time'] = item.initiated ? timeFormat(item.initiated) : "-";
            newObj['Call Direction'] = item.call_direction ? capitalizeFirstLetter(item.call_direction) : "-";
            csvArray.push(newObj);
        });

        let csv = convertArrayOfObjectsToCSV(csvArray);
        if (csv == null) return;
        const filename = `RCM-Voicemail-Report-${timeFormat(new Date(), true)}.csv`;
        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;

        }
        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
    }, [callDirectionSelectedValues, callFromSelectedValues, callToSelectedValues, callTypeSelectedValues, column.sortField, endDate, filterText, locationSelectedValues, reportUrl, sortDirection, startDate, timeFormat, totalRows]);


    const Export: any = React.useCallback(
        ({ onExport }: any) => (
            <Button
                disabled={disableExport}
                className="app-button-color"
                onClick={(e) => onExport((e.target as HTMLButtonElement).value)}
            >
                {disableExport && (
                    <span
                        className="spinner-border text-white mr-1"
                        style={{ width: "18px", height: "18px" }}
                        role="status"
                    ></span>
                )}{" "}
                Export
            </Button>
        ),
        [disableExport]
    );

    const ExportCSV = React.useMemo(
        () => <Export onExport={() => downloadCSV()} />,
        [downloadCSV, Export]
    );

    const popupTimeFormat = React.useCallback((date: Date) => {
        let formattedDate = new Date(date);
        let formattedTime: string = "";
        return formattedTime =
            ("00" + formattedDate.getDate()).slice(-2) +
            "-" +
            ("00" + (formattedDate.getMonth() + 1)).slice(-2) +
            "-" +
            formattedDate.getFullYear();
    }, []);

    // const [transcriptionText, setTranscriptionText] = React.useState("We are saving the voicemail transcription. Kindly check after few minutes");
    // const getTranscriptionText = React.useCallback((row: any) => {
    //     GetApiMethod('tenant/voicemail/get-transcription-text/' + row?.call_sid).then((res) => {
    //         if (res && res?.data && res.data?.data && res.data.data.transcriptionText) {
    //             setTranscriptionText(res.data.data.transcriptionText);
    //         }
    //     }).catch((err: any) => {
    //         console.log(err);
    //     });
    // }, []);


    const ExpandedComponents = React.useCallback((row: any) => {

        // getTranscriptionText(row.data);
        return (
            <table className="table table-bordered m-3" style={{ width: '100%', maxWidth: '50%' }} >
                <thead className="table-primary text-center">
                    <tr><td><b>Transcription Text</b></td> </tr>
                </thead>
                <tbody className="">
                    <tr><td>{(row?.data?.transcriptionText ? row?.data?.transcriptionText : "We are saving the voicemail transcription. Kindly check after a few minutes ")}</td></tr>
                </tbody>
            </table>
        )
    }, []);

    return (
        <>
            <Container fluid>
                <TopHeader heading="Voicemail Report" to="dashboard" />
                <DataTable
                    columns={columns}
                    data={data}
                    sortServer
                    onSort={handleSort}
                    progressPending={showLoader}
                    progressComponent={<AppLoaderTable />}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationResetDefaultPage={resetPaginationToggle}
                    subHeader
                    persistTableHead
                    subHeaderComponent={subHeaderComponent}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    actions={ExportCSV}
                    expandableRows={true}
                    expandableRowsComponent={ExpandedComponents}
                    expandOnRowClicked
                    onRowClicked={(row: any) => setExpandedCurrentRow(row)}
                    expandableRowExpanded={(row) => (row === currentExpandedRow)}
                    onRowExpandToggled={(bool, row: any) => setExpandedCurrentRow(row)}
                />
            </Container>
            {showReplayModal && (
                <AppModal
                    title={"Replay call recordings"}
                    bodyText={""}
                    hideFooter={true}
                    showCloseButton={true}
                    closeButtonEventEmitter={() => {
                        setShowReplayModal(false);
                        setReplayCallReportInfo(undefined);
                        setCustomLoading(false);
                    }}
                    modalSize={"xl"}
                >
                    <>
                        <div className="row">
                            {
                                replayCallReportInfo.type && (
                                    <div className="col-12 col-sm-6 col-md-4 mb-2">
                                        <div className="row">
                                            <div className="col-12">
                                                <b>Call type:</b>
                                            </div>
                                            <div className="col-12 app-overflow-break-word text-capitalize">{replayCallReportInfo.type}</div>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                replayCallReportInfo.location && replayCallReportInfo.location.name ? (
                                    <div className="col-12 col-sm-6 col-md-4 mb-2">
                                        <div className="row">
                                            <div className="col-12">
                                                <b>Location:</b>
                                            </div>
                                            <div className="col-12 app-overflow-break-word">
                                                {replayCallReportInfo.location.name}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                replayCallReportInfo.initiated && (
                                    <div className="col-12 col-sm-6 col-md-4 mb-2">
                                        <div className="row">
                                            <div className="col-12">
                                                <b>Initiated time:</b>
                                            </div>
                                            <div className="col-12 app-overflow-break-word">
                                                {timeFormat(replayCallReportInfo.initiated)}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                replayCallReportInfo.call_from && (
                                    <div className="col-12 col-sm-6 col-md-4 mb-2">
                                        <div className="row">
                                            <div className="col-12">
                                                <b>Call from:</b>
                                            </div>
                                            <div className="col-12 app-overflow-break-word">
                                                {
                                                    checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(replayCallReportInfo.call_from.toString()))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                replayCallReportInfo.call_to && (
                                    <div className="col-12 col-sm-6 col-md-4 mb-2">
                                        <div className="row">
                                            <div className="col-12">
                                                <b>Call to:</b>
                                            </div>
                                            <div className="col-12 app-overflow-break-word">
                                                {
                                                    checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(replayCallReportInfo.call_to.toString()))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="call-replay-audio-player-container d-flex align-items-center justify-content-center">
                            {replayCallReportInfo.mediaUrl ? (
                                <>
                                    {replayCallReportInfo.type && (
                                        <>
                                            <audio controls src={replayCallReportInfo.mediaUrl} autoPlay></audio>
                                        </>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div className="mt-4 d-flex align-items-center justify-content-center">
                            <button className="btn app-button-color">
                                <a className="app-button-text-color app-text-decoration-none"
                                    target="_blank"
                                    href={replayCallReportInfo.mediaUrl}
                                    download="video" >
                                    Download
                                </a>
                            </button>
                        </div>
                    </>
                </AppModal>
            )
            }

            {showTranscriptionModal && (
                <AppModal
                    title={"Transcription Text"}
                    bodyText={popupInfo && popupInfo.transcriptionText ? popupInfo.transcriptionText : ""}
                    hideFooter={true}
                    showCloseButton={true}
                    closeButtonEventEmitter={() => {
                        setShowTranscriptionModal(false);
                        setPopupInfo(undefined);
                        setCustomLoading(false);
                    }}
                />
            )
            }

            {deleteConfirmModal && (
                <AppModal
                    title={" Confirm Voicemail Delete"}
                    bodyText={`Are you sure you would like to delete the Voicemail from ${checkValueIsPhoneNumber(RemoveExtraCharsFromNumber(popupInfo.call_from.toString()))} received on ${popupTimeFormat(popupInfo.createdAt)}?`}
                    primaryButtonLabel={"Yes"}
                    secondaryButtonLabel={"No"}
                    primaryButtonEventEmitter={() => {
                        deleteRecordings()
                    }}
                    secondaryButtonEventEmitter={() => setDeleteConfirmModal(false)} />
            )
            }
        </>
    );
};

export default VoicemailReports;
